import { create } from 'zustand'
import { isHostAvailable } from '@/utils/devSdk'
import { RUNTIME_KEY, storage } from '@/utils/storage'

export type RuntimeEnv = 'client' | 'browser'

interface RuntimeState {
  runtime: RuntimeEnv
  isClient: boolean
  isBrowser: boolean
  init: () => RuntimeEnv
}

/**
 * `?runtime=client|browser` 可强制预览；否则按宿主（iframe / webview / 调试反连）判断。
 * 路由在模块求值时就要定 hash / history，因此这里保持同步、不创建 SDK。
 */
export function detectRuntime(): RuntimeEnv {
  const forced =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('runtime')
      : null
  if (forced === 'client' || forced === 'browser') return forced
  return isHostAvailable() ? 'client' : 'browser'
}

function apply(runtime: RuntimeEnv) {
  return {
    runtime,
    isClient: runtime === 'client',
    isBrowser: runtime === 'browser',
  }
}

const initial = detectRuntime()

export const useRuntimeStore = create<RuntimeState>((set) => ({
  ...apply(initial),
  init() {
    const runtime = detectRuntime()
    storage.set(RUNTIME_KEY, runtime)
    set(apply(runtime))
    return runtime
  },
}))
